import "./css/master.css";


let imageUrl = require("./images/header-img.png");
// let style = {
//     "height": '69px'
// }

function Header() {

    return (
        <div>
            <header className="site-header-02 js-toFixedByScroll is-fixed" >
                < div className="inner" >
                    <div className="content">
                        <div className="logo">
                            <h1 className="siteName">
                                <img src={imageUrl} alt="NEC Orchestrating a brighter world" width="175"
                                    height="13" /></h1>
                        </div>
                    </div>
                </div >
            </header >
        </div>
    );
}

export default Header;